<template>
  <div class="params">
    <div class="table-btns">
      <a-button type="primary" size="large" @click="setParams" style="float: right;margin-right:3.6%;margin-top: 1%">
        {{'下发当前参数'}}</a-button>
    </div>
    <a-form-model v-if="IotFlag.iotFlag==0" ref="modalForm" layout="inline" class="form-in-twocolumns" style="margin-top: 5%" :label-col="{span:9}" :wrapper-col="{span:14}">
<!--      <a-form-model-item label="播放欢迎语音楼层" prop="welcome_floor_num">-->
<!--        <a-input v-model="iotConfigs.welcome_floor_num" placeholder=""></a-input>-->
<!--      </a-form-model-item>-->
      <a-form-model-item label="播放语音的音量" prop="master">
        <a-input v-model="iotConfigs.master" placeholder="默认为80%"></a-input>
      </a-form-model-item>
      <a-form-model-item label="欢迎语音功能使能" prop="welcome_audio_enable">
        <a-input v-model="iotConfigs.welcome_audio_enable" placeholder=""></a-input>
      </a-form-model-item>
<!--      <a-form-model-item label="电梯是否是双开门" prop="double_door_enable">-->
<!--        <a-input v-model="iotConfigs.double_door_enable" placeholder="0代表否，1代表是，默认0"></a-input>-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="待机楼层" prop="STANDBY_FLOOR">-->
<!--        <a-input v-model="iotConfigs.STANDBY_FLOOR" placeholder="待机楼层之间请用英文逗号（,）连接"></a-input>-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="电梯楼层" prop="floors">-->
<!--        <a-input v-model="iotConfigs.floors" placeholder=""></a-input>-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="楼层每层高度序列" prop="floor_height">-->
<!--        <a-input v-model="iotConfigs.floor_height" placeholder="楼层高度之间请用英文逗号（,）连接"></a-input>-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="当前标定楼层" prop="calibrate_floor_num">-->
<!--        <a-input v-model="iotConfigs.calibrate_floor_num" placeholder=""></a-input>-->
<!--      </a-form-model-item>-->
      <a-form-model-item label="当前楼层测量高度和实际高度差值的阈值" prop="hei_threshold_base">
        <a-input v-model="iotConfigs.hei_threshold_base" placeholder="默认为0.5m"></a-input>
      </a-form-model-item>
      <a-form-model-item label="开锁区域外停止故障撤销时间" prop="out_cancle_time_span">
        <a-input v-model="iotConfigs.out_cancle_time_span" placeholder="默认为10分钟"></a-input>
      </a-form-model-item>
      <a-form-model-item label="开门最大超时时间" prop="FAULE_OPEN_DOOR_TIME">
        <a-input v-model="iotConfigs.FAULE_OPEN_DOOR_TIME" placeholder=""></a-input>
      </a-form-model-item>
      <a-form-model-item label="关门最大超时时间" prop="FAULE_CLOSE_DOOR_TIME">
        <a-input v-model="iotConfigs.FAULE_CLOSE_DOOR_TIME" placeholder=""></a-input>
      </a-form-model-item>
      <a-form-model-item label="长时间驻留最大超时时间" prop="TRAPPED_PEOPLE_TIME">
        <a-input v-model="iotConfigs.TRAPPED_PEOPLE_TIME" placeholder=""></a-input>
      </a-form-model-item>
      <a-form-model-item label="电梯物联网故障使能标志" prop="all_fault_enable">
        <a-input v-model="iotConfigs.all_fault_enable" placeholder=""></a-input>
      </a-form-model-item>
      <a-form-model-item label="轿厢在开锁区域外停止故障使能标志" prop="out_detect_enable_flag">
        <a-input v-model="iotConfigs.out_detect_enable_flag" placeholder=""></a-input>
      </a-form-model-item>
      <a-form-model-item label="轿厢在开锁区域外停止故障上传录像使能" prop="out_upload_video_enable">
        <a-select v-model="iotConfigs.out_upload_video_enable" placeholder="1使能，0禁用，默认禁用">
          <a-select-option :value="1">使能</a-select-option>
          <a-select-option :value="0">禁用</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="无源报警功能使能" prop="alarm_enable">
        <a-input v-model="iotConfigs.alarm_enable" placeholder=""></a-input>
      </a-form-model-item>
      <a-form-model-item label="无源报警上传录像使能" prop="passive_alarm_upload_video_enable">
        <a-select v-model="iotConfigs.passive_alarm_upload_video_enable" placeholder="1使能，0禁用，默认禁用">
          <a-select-option :value="1">使能</a-select-option>
          <a-select-option :value="0">禁用</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="有源报警使能标志" prop="alarm_active_enable">
        <a-input v-model="iotConfigs.alarm_active_enable" placeholder=""></a-input>
      </a-form-model-item>
      <a-form-model-item label="有源报警上传录像使能" prop="alarm_active_upload_video_enable">
        <a-select v-model="iotConfigs.alarm_active_upload_video_enable" placeholder="1使能，0禁用，默认禁用">
          <a-select-option :value="1">使能</a-select-option>
          <a-select-option :value="0">禁用</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="生产模式使能" prop="Manufacture_mode">
        <a-input v-model="iotConfigs.Manufacture_mode" placeholder=""></a-input>
      </a-form-model-item>
      <a-form-model-item label="安全回路断路故障使能" prop="safety_loop_enable">
        <a-input v-model="iotConfigs.safety_loop_enable" placeholder=""></a-input>
      </a-form-model-item>
      <a-form-model-item label="安全回路断路故障上传录像使能" prop="safety_loop_upload_video_enable">
        <a-select v-model="iotConfigs.safety_loop_upload_video_enable" placeholder="1使能，0禁用，默认禁用">
          <a-select-option :value="1">使能</a-select-option>
          <a-select-option :value="0">禁用</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="开门故障使能" prop="open_enable">
        <a-input v-model="iotConfigs.open_enable" placeholder=""></a-input>
      </a-form-model-item>
      <a-form-model-item label="开门故障上传录像使能" prop="open_upload_video_enable">
        <a-select v-model="iotConfigs.open_upload_video_enable" placeholder="1使能，0禁用，默认禁用">
          <a-select-option :value="1">使能</a-select-option>
          <a-select-option :value="0">禁用</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="关门故障使能" prop="close_enable">
        <a-input v-model="iotConfigs.close_enable" placeholder=""></a-input>
      </a-form-model-item>
      <a-form-model-item label="关门故障上传录像使能" prop="close_upload_video_enable">
        <a-select v-model="iotConfigs.close_upload_video_enable" placeholder="1使能，0禁用，默认禁用">
          <a-select-option :value="1">使能</a-select-option>
          <a-select-option :value="0">禁用</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="困人故障使能" prop="trapped_enable">
        <a-input v-model="iotConfigs.trapped_enable" placeholder=""></a-input>
      </a-form-model-item>
      <a-form-model-item label="困人故障上传录像使能" prop="trapped_fault_upload_video_enable">
        <a-select v-model="iotConfigs.trapped_fault_upload_video_enable" placeholder="1使能，0禁用，默认禁用">
          <a-select-option :value="1">使能</a-select-option>
          <a-select-option :value="0">禁用</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="轿厢意外移动故障使能" prop="accidental_movement_enable">
        <a-input v-model="iotConfigs.accidental_movement_enable" placeholder=""></a-input>
      </a-form-model-item>
      <a-form-model-item label="轿厢意外移动故障上传录像使能" prop="accidental_movement_upload_video_enable">
        <a-select v-model="iotConfigs.accidental_movement_upload_video_enable" placeholder="1使能，0禁用，默认禁用">
          <a-select-option :value="1">使能</a-select-option>
          <a-select-option :value="0">禁用</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="电动机运转时间限制器动作使能" prop="motor_fault_enable">
        <a-input v-model="iotConfigs.motor_fault_enable" placeholder=""></a-input>
      </a-form-model-item>
      <a-form-model-item label="电动机运转时间限制器动作上传录像使能" prop="motor_upload_video_enable">
        <a-select v-model="iotConfigs.motor_upload_video_enable" placeholder="1使能，0禁用，默认禁用">
          <a-select-option :value="1">使能</a-select-option>
          <a-select-option :value="0">禁用</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="楼层位置丢失故障使能" prop="floor_loss_enable">
        <a-input v-model="iotConfigs.floor_loss_enable" placeholder=""></a-input>
      </a-form-model-item>
      <a-form-model-item label="楼层位置丢失故障上传录像使能" prop="floor_loss_upload_video_enable">
        <a-select v-model="iotConfigs.floor_loss_upload_video_enable" placeholder="1使能，0禁用，默认禁用">
          <a-select-option :value="1">使能</a-select-option>
          <a-select-option :value="0">禁用</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="其它阻止电梯再启动的故障使能" prop="other_fault_enable">
        <a-input v-model="iotConfigs.other_fault_enable" placeholder=""></a-input>
      </a-form-model-item>
      <a-form-model-item label="其它阻止电梯再启动故障上传录像使能" prop="other_upload_video_enable">
        <a-select v-model="iotConfigs.other_upload_video_enable" placeholder="1使能，0禁用，默认禁用">
          <a-select-option :value="1">使能</a-select-option>
          <a-select-option :value="0">禁用</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="开门运行故障使能标志" prop="open_run_fault_enable">
        <a-select v-model="iotConfigs.open_run_fault_enable" placeholder="1使能，0禁用，默认使能">
          <a-select-option :value="1">使能</a-select-option>
          <a-select-option :value="0">禁用</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="开门运行故障上传录像使能" prop="open_run_upload_video_enable">
        <a-select v-model="iotConfigs.open_run_upload_video_enable" placeholder="1使能，0禁用，默认禁用">
          <a-select-option :value="1">使能</a-select-option>
          <a-select-option :value="0">禁用</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="开门运行故障撤销时间" prop="open_run_recall_time_span">
        <a-input v-model="iotConfigs.open_run_recall_time_span" placeholder="默认10分钟" suffix="分钟"></a-input>
      </a-form-model-item>
      <a-form-model-item label="反复开关门故障上传录像使能" prop="repeatedly_open_close_upload_video_enable">
        <a-select v-model="iotConfigs.repeatedly_open_close_upload_video_enable" placeholder="1使能，0禁用，默认禁用">
          <a-select-option :value="1">使能</a-select-option>
          <a-select-option :value="0">禁用</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="检修事件上传录像使能" prop="Service_Mode_upload_video_enable">
        <a-select v-model="iotConfigs.Service_Mode_upload_video_enable" placeholder="1使能，0禁用，默认禁用">
          <a-select-option :value="1">使能</a-select-option>
          <a-select-option :value="0">禁用</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="亮度队列长度" prop="brightness_list_max">
        <a-input v-model="iotConfigs.brightness_list_max" placeholder="默认50个"></a-input>
      </a-form-model-item>
      <a-form-model-item label="计算亮度队列均值时间间隔" prop="brightness_mean_acc_interval">
        <a-input v-model="iotConfigs.brightness_mean_acc_interval" placeholder="默认30分钟"></a-input>
      </a-form-model-item>
      <a-form-model-item label="亮度最低阈值" prop="brightness_value_min">
        <a-input v-model="iotConfigs.brightness_value_min" placeholder="默认40"></a-input>
      </a-form-model-item>
      <a-form-model-item label="亮度最高阈值" prop="brightness_value_max">
        <a-input v-model="iotConfigs.brightness_value_max" placeholder="默认80"></a-input>
      </a-form-model-item>
    </a-form-model>
    <div style="margin-top: 5%">
    <a-text v-if="IotFlag.iotFlag==1" style="margin-left: 3%;font-size: 30px">基础参数：</a-text>
    <a-form-model v-if="IotFlag.iotFlag==1" ref="modalForm" layout="inline" class="form-in-twocolumns" style="margin-bottom: 2%" :label-col="{span:9}" :wrapper-col="{span:14}">
      <a-form-model-item label="电梯物联网心跳周期" prop="heartbeat_cycle">
        <a-input v-model="iotConfigs.heartbeat_cycle" placeholder=""></a-input>
      </a-form-model-item>
      <a-form-model-item label="楼层气压参考值更新时间" prop="T_Pi_ref">
        <a-input v-model="iotConfigs.T_Pi_ref" placeholder=""></a-input>
      </a-form-model-item>
      <a-form-model-item label="AI模块实时状态失连最大超时时间" prop="AI_REALSTATE_RECEIVE_TIME">
        <a-input v-model="iotConfigs.AI_REALSTATE_RECEIVE_TIME" placeholder=""></a-input>
      </a-form-model-item>
      <a-form-model-item label="人流量统计常数" prop="cumulative_person_const">
        <a-input v-model="iotConfigs.cumulative_person_const" placeholder=""></a-input>
      </a-form-model-item>
      <a-form-model-item label="重启后不上报门区外停梯故障时间长度" prop="after_up_no_out_fault_time">
        <a-input v-model="iotConfigs.after_up_no_out_fault_time" placeholder=""></a-input>
      </a-form-model-item>
    </a-form-model>
    <a-text v-if="IotFlag.iotFlag==1" style="margin-left: 3%;font-size: 30px">气压计相关参数：</a-text>
    <a-form-model v-if="IotFlag.iotFlag==1" ref="modalForm" layout="inline" class="form-in-twocolumns" style="margin-bottom: 2%" :label-col="{span:9}" :wrapper-col="{span:14}">
      <a-form-model-item label="气压计测量精度" prop="PRESSURE_PRECISION">
        <a-input v-model="iotConfigs.PRESSURE_PRECISION" placeholder=""></a-input>
      </a-form-model-item>
      <a-form-model-item label="气压计测量精度的倍数" prop="BASE_PTH">
        <a-input v-model="iotConfigs.BASE_PTH" placeholder=""></a-input>
      </a-form-model-item>
      <a-form-model-item label="气压计平滑队列最大长度" prop="PRESSUER_LIST_MAX">
        <a-input v-model="iotConfigs.PRESSUER_LIST_MAX" placeholder=""></a-input>
      </a-form-model-item>
    </a-form-model>

      <a-text v-if="IotFlag.iotFlag==1" style="margin-left: 3%;font-size: 30px">楼层判断相关参数：</a-text>
      <a-form-model v-if="IotFlag.iotFlag==1" ref="modalForm" layout="inline" class="form-in-twocolumns" style="margin-bottom: 2%" :label-col="{span:9}" :wrapper-col="{span:14}">
      <a-form-model-item label="楼层判断方式" prop="floor_sensor_mode">
        <a-input v-model="iotConfigs.floor_sensor_mode" placeholder="1代表气压计，2代表干簧管，3代表互感器，默认为1"></a-input>
      </a-form-model-item>
      <a-form-model-item label="气压和高度换算常数" prop="pressure_height_constant">
        <a-input v-model="iotConfigs.pressure_height_constant" placeholder="默认为0.111"></a-input>
      </a-form-model-item>
      <a-form-model-item label="气压和高度换算常数阈值" prop="pressure_height_constant_threshold">
        <a-input v-model="iotConfigs.pressure_height_constant_threshold" placeholder="默认为0.005"></a-input>
      </a-form-model-item>
      <a-form-model-item label="气压和高度换算常数的队列个数" prop="pressure_height_constant_list_max_len">
        <a-input v-model="iotConfigs.pressure_height_constant_list_max_len" placeholder="默认为8个"></a-input>
      </a-form-model-item>
      <a-form-model-item label="气压和高度换算常数参考值最大队列长度" prop="pressure_height_constant_reference_list_max">
        <a-input v-model="iotConfigs.pressure_height_constant_reference_list_max" placeholder="默认为5000"></a-input>
      </a-form-model-item>
      <a-form-model-item label="气压和高度换算常数与参考值的比值上限" prop="repeatedly_open_close_max">
        <a-input v-model="iotConfigs.pressure_height_constant_reference_threshold" placeholder="默认为0.08"></a-input>
      </a-form-model-item>
      </a-form-model>

      <a-text v-if="IotFlag.iotFlag==1" style="margin-left: 3%;font-size: 30px">困人故障相关参数：</a-text>
      <a-form-model v-if="IotFlag.iotFlag==1" ref="modalForm" layout="inline" class="form-in-twocolumns" style="margin-bottom: 2%" :label-col="{span:9}" :wrapper-col="{span:14}">
      <a-form-model-item label="困人过程中有人的概率" prop="trapped_person_appear_probability">
        <a-input v-model="iotConfigs.trapped_person_appear_probability" placeholder=""></a-input>
      </a-form-model-item>
      <a-form-model-item label="发生困人长时间驻留前的时间" prop="before_long_stay">
        <a-input v-model="iotConfigs.before_long_stay" placeholder="默认为3分钟"></a-input>
      </a-form-model-item>
      <a-form-model-item label="发生困人长时间驻留后的时间" prop="after_long_stay">
        <a-input v-model="iotConfigs.after_long_stay" placeholder="默认为30分钟"></a-input>
      </a-form-model-item>
      </a-form-model>

      <a-text v-if="IotFlag.iotFlag==1" style="margin-left: 3%;font-size: 30px">轿厢在开锁区域外停止故障相关参数：</a-text>
      <a-form-model v-if="IotFlag.iotFlag==1" ref="modalForm" layout="inline" class="form-in-twocolumns" style="margin-bottom: 2%" :label-col="{span:9}" :wrapper-col="{span:14}">
      <a-form-model-item label="每米增加的误差" prop="step_threshold">
        <a-input v-model="iotConfigs.step_threshold" placeholder="默认为0.01m"></a-input>
      </a-form-model-item>
      <a-form-model-item label="高度差值阈值不变的最大距离" prop="hei_threshold_hold_max_distance">
        <a-input v-model="iotConfigs.hei_threshold_hold_max_distance" placeholder="默认为40m"></a-input>
      </a-form-model-item>
      <a-form-model-item label="高度差值阈值上限" prop="hei_threshold_hold_max_distance">
        <a-input v-model="iotConfigs.hei_threshold_max" placeholder="默认为1m"></a-input>
      </a-form-model-item>
      <a-form-model-item label="轿厢外停止故障取消电梯连续运行状态数" prop="out_cancel_car_move_continuation_times">
        <a-input v-model="iotConfigs.out_cancel_car_move_continuation_times" placeholder=""></a-input>
      </a-form-model-item>
      </a-form-model>

      <a-text v-if="IotFlag.iotFlag==1" style="margin-left: 3%;font-size: 30px">开关门故障检测参数：</a-text>
      <a-form-model v-if="IotFlag.iotFlag==1" ref="modalForm" layout="inline" class="form-in-twocolumns" style="margin-bottom: 2%" :label-col="{span:9}" :wrapper-col="{span:14}">
      <a-form-model-item label="反复开关门时间阈值" prop="repeatedly_open_close_time_threshold">
        <a-input v-model="iotConfigs.repeatedly_open_close_time_threshold" placeholder="默认为3分钟"></a-input>
      </a-form-model-item>
      <a-form-model-item label="反复开关门次数" prop="repeatedly_open_close_max">
        <a-input v-model="iotConfigs.repeatedly_open_close_max" placeholder="默认为10次"></a-input>
      </a-form-model-item>
      <a-form-model-item label="开门故障撤销时间" prop="open_cancle_time_span">
        <a-input v-model="iotConfigs.open_cancle_time_span" placeholder="默认为10分钟（如果十分钟内出现一次开关门）"></a-input>
      </a-form-model-item>
      <a-form-model-item label="关门故障撤销时间" prop="close_cancle_time_span">
        <a-input v-model="iotConfigs.close_cancle_time_span" placeholder="默认为10分钟（如果十分钟内出现一次开关门）"></a-input>
      </a-form-model-item>
      <a-form-model-item label="挡门时间阈值" prop="block_door_time_threshold">
        <a-input v-model="iotConfigs.block_door_time_threshold" placeholder="默认120秒"></a-input>
      </a-form-model-item>
      <a-form-model-item label="挡门事件阈值" prop="block_door_acc_threshold">
        <a-input v-model="iotConfigs.block_door_acc_threshold" placeholder="默认0.92"></a-input>
      </a-form-model-item>
      </a-form-model>

      <a-text v-if="IotFlag.iotFlag==1" style="margin-left: 3%;font-size: 30px">电动机限制器动作故障检测参数：</a-text>
      <a-form-model v-if="IotFlag.iotFlag==1" ref="modalForm" layout="inline" class="form-in-twocolumns" style="margin-bottom: 2%" :label-col="{span:9}" :wrapper-col="{span:14}">
      <a-form-model-item label="电动机限制器运作气压阈值" prop="motor_threshold">
        <a-input v-model="iotConfigs.motor_threshold" placeholder=""></a-input>
      </a-form-model-item>
      <a-form-model-item label="电动机运作检测连续个数" prop="motor_continuation_times">
        <a-input v-model="iotConfigs.motor_continuation_times" placeholder=""></a-input>
      </a-form-model-item>
      <a-form-model-item label="电动机限制器运作时间阈值" prop="motor_time_threshold">
        <a-input v-model="iotConfigs.motor_time_threshold" placeholder=""></a-input>
      </a-form-model-item>
      <a-form-model-item label="电动机运作故障取消时间" prop="motor_cancel_time">
        <a-input v-model="iotConfigs.motor_cancel_time" placeholder=""></a-input>
      </a-form-model-item>
      </a-form-model>

      <a-text v-if="IotFlag.iotFlag==1" style="margin-left: 3%;font-size: 30px">楼层丢失故障检测参数：</a-text>
      <a-form-model v-if="IotFlag.iotFlag==1" ref="modalForm" layout="inline" class="form-in-twocolumns" style="margin-bottom: 2%" :label-col="{span:9}" :wrapper-col="{span:14}">
      <a-form-model-item label="楼层丢失气压最低阈值" prop="loss_floor_pressure_lowest_threshold">
        <a-input v-model="iotConfigs.loss_floor_pressure_lowest_threshold" placeholder=""></a-input>
      </a-form-model-item>
      <a-form-model-item label="楼层丢失气压最高阈值" prop="loss_floor_pressure_highest_threshold">
        <a-input v-model="iotConfigs.loss_floor_pressure_highest_threshold" placeholder=""></a-input>
      </a-form-model-item>
      <a-form-model-item label="楼层丢失检测连续个数" prop="loss_floor_continuation_times">
        <a-input v-model="iotConfigs.loss_floor_continuation_times" placeholder=""></a-input>
      </a-form-model-item>
      <a-form-model-item label="楼层丢失故障取消阈值" prop="loss_fault_cancel_threshold">
        <a-input v-model="iotConfigs.loss_fault_cancel_threshold" placeholder=""></a-input>
      </a-form-model-item>
      <a-form-model-item label="楼层丢失故障取消检测连续个数" prop="loss_fault_cancel_continuation_times">
        <a-input v-model="iotConfigs.loss_fault_cancel_continuation_times" placeholder=""></a-input>
      </a-form-model-item>
      <a-form-model-item label="楼层丢失参考陀螺仪个数" prop="mpu_floor_loss_num">
        <a-input v-model="iotConfigs.mpu_floor_loss_num" placeholder="默认1个"></a-input>
      </a-form-model-item>
      <a-form-model-item label="楼层丢失参考陀螺仪阈值" prop="mpu_floor_loss_threshold">
        <a-input v-model="iotConfigs.mpu_floor_loss_threshold" placeholder="默认0.03"></a-input>
      </a-form-model-item>
      </a-form-model>

      <a-text v-if="IotFlag.iotFlag==1" style="margin-left: 3%;font-size: 30px">楼层自动纠正功能参数：</a-text>
      <a-form-model v-if="IotFlag.iotFlag==1" ref="modalForm" layout="inline" class="form-in-twocolumns" style="margin-bottom: 2%" :label-col="{span:9}" :wrapper-col="{span:14}">
      <a-form-model-item label="楼层自动纠正，电梯运行最大次数" prop="floor_auto_check_run_times">
        <a-input v-model="iotConfigs.floor_auto_check_run_times" placeholder="默认为8次"></a-input>
      </a-form-model-item>
      <a-form-model-item label="楼层自动纠正时间间隔" prop="floor_auto_check_time">
        <a-input v-model="iotConfigs.floor_auto_check_time" placeholder="默认为3分钟"></a-input>
      </a-form-model-item>
      </a-form-model>

      <a-text v-if="IotFlag.iotFlag==1" style="margin-left: 3%;font-size: 30px">其他故障检测参数：</a-text>
      <a-form-model v-if="IotFlag.iotFlag==1" ref="modalForm" layout="inline" class="form-in-twocolumns" style="margin-bottom: 2%" :label-col="{span:9}" :wrapper-col="{span:14}">
      <a-form-model-item label="其他故障参考队列最大长度" prop="other_fault_reference_list_max">
        <a-input v-model="iotConfigs.other_fault_reference_list_max" placeholder="默认500"></a-input>
      </a-form-model-item>
      <a-form-model-item label="其他故障超速阈值" prop="other_fault_threshold">
        <a-input v-model="iotConfigs.other_fault_threshold" placeholder="默认0.5"></a-input>
      </a-form-model-item>
      <a-form-model-item label="其他故障解除阈值" prop="other_fault_cancel_threshold">
        <a-input v-model="iotConfigs.other_fault_cancel_threshold" placeholder="默认0.05"></a-input>
      </a-form-model-item>
      <a-form-model-item label="其他故障实时队列长度" prop="other_fault_realtime_list_num">
        <a-input v-model="iotConfigs.other_fault_realtime_list_num" placeholder="默认3个"></a-input>
      </a-form-model-item>
      </a-form-model>

      <a-text v-if="IotFlag.iotFlag==1" style="margin-left: 3%;font-size: 30px">陀螺仪相关参数：</a-text>
      <a-form-model v-if="IotFlag.iotFlag==1" ref="modalForm" layout="inline" class="form-in-twocolumns" style="margin-bottom: 2%" :label-col="{span:9}" :wrapper-col="{span:14}">
      <a-form-model-item label="陀螺仪读取周期" prop="mpu_read_cycle">
        <a-input v-model="iotConfigs.mpu_read_cycle" placeholder="默认10ms"></a-input>
      </a-form-model-item>
      <a-form-model-item label="陀螺仪重力加速度队列长度" prop="mpu_acceleration_list_num">
        <a-input v-model="iotConfigs.mpu_acceleration_list_num" placeholder="默认5个"></a-input>
      </a-form-model-item>
      <a-form-model-item label="陀螺仪重力加速度参考队列长度" prop="mpu_acceleration_ref_list_num">
        <a-input v-model="iotConfigs.mpu_acceleration_ref_list_num" placeholder="默认500"></a-input>
      </a-form-model-item>
      </a-form-model>

      <a-text v-if="IotFlag.iotFlag==1" style="margin-left: 3%;font-size: 30px">干簧管相关参数：</a-text>
      <a-form-model v-if="IotFlag.iotFlag==1" ref="modalForm" layout="inline" class="form-in-twocolumns" style="margin-bottom: 2%" :label-col="{span:9}" :wrapper-col="{span:14}">
      <a-form-model-item label="干簧管采集信号周期" prop="double_door_calculation_cycle">
        <a-input v-model="iotConfigs.double_door_calculation_cycle" placeholder="默认10ms"></a-input>
      </a-form-model-item>
      <a-form-model-item label="干簧管开关门到位队列长度" prop="double_door_list_sum">
        <a-input v-model="iotConfigs.double_door_list_sum" placeholder="默认10个"></a-input>
      </a-form-model-item>
      <a-form-model-item label="干簧管开关门判断阈值" prop="double_door_list_max">
        <a-input v-model="iotConfigs.double_door_list_max" placeholder="默认7个"></a-input>
      </a-form-model-item>
      </a-form-model>

      <a-text v-if="IotFlag.iotFlag==1" style="margin-left: 3%;font-size: 30px">GPIO相关参数：</a-text>
      <a-form-model v-if="IotFlag.iotFlag==1" ref="modalForm" layout="inline" class="form-in-twocolumns" style="margin-bottom: 2%" :label-col="{span:9}" :wrapper-col="{span:14}">
      <a-form-model-item label="有源报警有效电平配置" prop="alarm_active_voltage_enable">
        <a-input v-model="iotConfigs.alarm_active_voltage_enable" placeholder="1为高电平，0为低电平"></a-input>
      </a-form-model-item>
      <a-form-model-item label="无源源报警有效电平配置" prop="alarm_voltage_enable">
        <a-input v-model="iotConfigs.alarm_voltage_enable" placeholder="1为高电平，0为低电平"></a-input>
      </a-form-model-item>
      <a-form-model-item label="gpio触发时长" prop="floor_auto_check_time">
        <a-input v-model="iotConfigs.gpio_active_time" placeholder="默认为100ms"></a-input>
      </a-form-model-item>
      </a-form-model>

      <a-text v-if="IotFlag.iotFlag==1" style="margin-left: 3%;font-size: 30px">运动停止相关参数：</a-text>
      <a-form-model v-if="IotFlag.iotFlag==1" ref="modalForm" layout="inline" class="form-in-twocolumns" style="margin-bottom: 2%" :label-col="{span:9}" :wrapper-col="{span:14}">
      <a-form-model-item label="判断轿厢停止状态对列长度" prop="car_state_continuation_times">
        <a-input v-model="iotConfigs.car_state_continuation_times" placeholder=""></a-input>
      </a-form-model-item>
      <a-form-model-item label="判断轿厢运行状态对列长度" prop="car_move_state_continuation_times">
        <a-input v-model="iotConfigs.car_move_state_continuation_times" placeholder=""></a-input>
      </a-form-model-item>
      <a-form-model-item label="电梯运动参考陀螺仪个数" prop="mpu_car_move_num">
        <a-input v-model="iotConfigs.mpu_car_move_num" placeholder="默认1个"></a-input>
      </a-form-model-item>
      <a-form-model-item label="电梯运动参考陀螺仪阈值" prop="mpu_car_move_threshold">
        <a-input v-model="iotConfigs.mpu_car_move_threshold" placeholder="默认0.03"></a-input>
      </a-form-model-item>
      <a-form-model-item label="电梯运动参考陀螺仪队列个数" prop="mpu_car_move_list_num">
        <a-input v-model="iotConfigs.mpu_car_move_list_num" placeholder="默认5个"></a-input>
      </a-form-model-item>
      </a-form-model>

      <a-text v-if="IotFlag.iotFlag==1" style="margin-left: 3%;font-size: 30px">意外移动故障相关参数：</a-text>
      <a-form-model v-if="IotFlag.iotFlag==1" ref="modalForm" layout="inline" class="form-in-twocolumns" style="margin-bottom: 2%" :label-col="{span:9}" :wrapper-col="{span:14}">
      <a-form-model-item label="意外移动故障连续检测的次数" prop="detect_other_fault_continuation_times">
        <a-input v-model="iotConfigs.detect_other_fault_continuation_times" placeholder=""></a-input>
      </a-form-model-item>
    </a-form-model>

      <a-text v-if="IotFlag.iotFlag==1" style="margin-left: 3%;font-size: 30px">楼层自动纠正相关参数：</a-text>
      <a-form-model v-if="IotFlag.iotFlag==1" ref="modalForm" layout="inline" class="form-in-twocolumns" style="margin-bottom: 2%" :label-col="{span:9}" :wrapper-col="{span:14}">
        <a-form-model-item label="楼层自动纠正，停靠最多楼层" prop="floor_auto_check_lowest_num">
          <a-input v-model="iotConfigs.floor_auto_check_lowest_num" placeholder="默认为最小正楼层"></a-input>
        </a-form-model-item>
        <a-form-model-item label="楼层自动纠正功能使能标志" prop="floor_auto_check_time">
          <a-input v-model="iotConfigs.floor_auto_check_enable" placeholder="默认为1"></a-input>
        </a-form-model-item>
      </a-form-model>
    </div>
  </div>
</template>
<script>
import {
  addParamsBatchLog,
  getDevicegroupdevListByCondition, getDevicegroupListByCondition,
  getDeviceparamChildLisByParentId,
  modifyParamsBatchLog,
  setDeviceparamValueList
} from "A/ai";
import moment from "moment";
import {getCache} from "U/index";
export default {
  name: "iot",
  props:{
    IotFlag:{
      default: null
    }
  },
  data() {
    return {
      iotConfigs:{
        MPU_RELATION_MOTION_ENABLE:'',
        PRESSURE_PRECISION:'',
        BASE_PTH:'',
        T_Pi_ref:'',
        PRESSUER_LIST_MAX:'',
        FAULE_CLOSE_DOOR_TIME:'',
        FAULE_OPEN_DOOR_TIME:'',
        TRAPPED_PEOPLE_TIME:'',
        AI_REALSTATE_RECEIVE_TIME:'',
        STANDBY_FLOOR:'',
        detect_other_fault_continuation_times:'',
        cumulative_person_const:'',
        trapped_person_appear_probability:'',
        floor_height:'',
        out_cancel_car_move_continuation_times:'',
        car_state_continuation_times:'',
        out_detect_enable_flag:'',
        after_up_no_out_fault_time:'',
        heartbeat_cycle:'',
        all_fault_enable:'',
        passive_alarm_enable:'',
        welcome_audio_enable:'',
        motor_threshold:'',
        motor_continuation_times:'',
        motor_time_threshold:'',
        motor_cancel_time:'',
        loss_floor_pressure_lowest_threshold:'',
        loss_floor_pressure_highest_threshold:'',
        loss_floor_continuation_times:'',
        loss_fault_cancel_threshold:'',
        loss_fault_cancel_continuation_times:'',
        alarm_active_enable:'',
        Manufacture_mode:'',
        alarm_active_voltage_enable:'',
        alarm_voltage_enable:'',
        safety_loop_enable:'',
        close_enable:'',
        open_enable:'',
        trapped_enable:'',
        other_fault_enable:'',
        accidental_movement_enable:'',
        motor_fault_enable:'',
        floor_loss_enable:'',
        floors:'',
        car_move_state_continuation_times:'',
        welcome_floor_num:'',
        calibrate_floor_num:'',
        floor_auto_check_run_times:'',
        floor_auto_check_lowest_num:'',
        floor_auto_check_time:'',
        floor_auto_check_enable:'',
        gpio_active_time:'',
        master:'',
        pressure_height_constant:'',
        pressure_height_constant_threshold:'',
        pressure_height_constant_list_max_len:'',
        out_cancle_time_span:'',
        before_long_stay:'',
        after_long_stay:'',
        trapped_alarm_enable:'',
        hei_threshold_base:'',
        step_threshold:'',
        hei_threshold_hold_max_distance:'',
        hei_threshold_max:'',
        floor_sensor_mode:'',
        pressure_height_constant_study_begin:'',
        pressure_height_constant_study_end:'',
        repeatedly_open_close_time_threshold:'',
        repeatedly_open_close_max:'',
        recall_event_flag:'',
        open_cancle_time_span:'',
        close_cancle_time_span:'',
        pressure_height_constant_reference_list_max:'',
        pressure_height_constant_reference_threshold:'',
        double_door_enable:'',
        double_door_calculation_cycle:'',
        double_door_list_sum:'',
        double_door_list_max:'',
        other_fault_reference_list_max:'',
        other_fault_threshold:'',
        other_fault_cancel_threshold:'',
        mpu_read_cycle:'',
        mpu_acceleration_list_num:'',
        mpu_acceleration_ref_list_num:'',
        mpu_car_move_num:'',
        mpu_car_move_threshold:'',
        mpu_floor_loss_num:'',
        mpu_floor_loss_threshold:'',
        mpu_car_move_list_num:'',
        block_door_time_threshold:'',
        block_door_acc_threshold:'',
        other_fault_realtime_list_num:'',
        open_run_fault_enable:'',
        Xianshi_device_sn_num:'',
        open_run_recall_time_span:'',
        Xianshi_module_enable:'',
        long_stay_event_enable:'',

        //故障联动通话使能参数
        safety_loop_alarm_enable:'',
        open_alarm_enable:'',
        close_alarm_enable:'',
        out_alarm_enable:'',
        accidental_movement_alarm_enable:'',
        motor_alarm_enable:'',
        floor_loss_alarm_enable:'',
        other_alarm_enable:'',
        trapped_fault_alarm_enable:'',
        repeatedly_open_close_alarm_enable:'',
        open_run_alarm_enable:'',

        //事件联动通话使能参数
        long_stay_alarm_enable:'',
        block_door_alarm_enable:'',

        speed_max:'',
        PARA_SD_CARD_EXIST:'',

        //事件录像上传使能
        Service_Mode_upload_video_enable:'',
        passive_alarm_upload_video_enable:'',
        alarm_active_upload_video_enable:'',
        safety_loop_upload_video_enable:'',
        open_upload_video_enable:'',
        close_upload_video_enable:'',
        out_upload_video_enable:'',
        accidental_movement_upload_video_enable:'',
        motor_upload_video_enable:'',
        floor_loss_upload_video_enable:'',
        other_upload_video_enable:'',
        trapped_fault_upload_video_enable:'',
        repeatedly_open_close_upload_video_enable:'',
        open_run_upload_video_enable:'',
      },
      paramsdata:'',
      devicemoduletype: '',
      devicenum: '',
      modelnum: '',
      methodList: [],
      tabKey: '20',
      status:false,
      username:'',
      devicegroupid:'',
      devicegroupname:'',
      devicenums:[],
      devicenames:[],
      result:0,
    }
  },
  watch: {
    devicemoduletype(val) {
      if (val) {
        this.getMethods();
      }
    },
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.devicemoduletype = this.$route.params.devicemoduletype||'1';
      this.devicenum = this.$route.params.devicenum||'';
      this.modelnum = this.$route.params.modelnum||'';
      this.devicegroupid = this.$route.params.devicegroupid||'';
      this.getDevicenum(this.devicegroupid);
      let logininfo = getCache('logininfo', true);
      if (logininfo) {
        this.username = logininfo.usernames;
      }
    },
    getDevicenum(devicegroupid){
      let params = {
        devicegroupid: devicegroupid,
      }
      getDevicegroupdevListByCondition(params).then(res => {
        if (res && res.returncode == '0') {
          for(var i=0;i<res.item.length;i++){
            this.devicenums.push(res.item[i].devicenum)
            this.devicenames.push(res.item[i].devicename)
            this.devicegroupname=res.item[0].devicegroupname
          }
        }
      })
    },
    getMethods() {
      this.methodList = [];
      this.tabKey = '20';
      this.paramsList = [];
      let params = {
        parentid: this.devicemoduletype
      };
      this.showLoading();
      getDeviceparamChildLisByParentId(params).then(res => {
        this.hideLoading();
        if(res && res.returncode == '0') {
          this.methodList = res.item||[];
        }
      }).catch(err => {
        this.hideLoading();
      })
    },
    updateParams(){
      let param = {
        paramsid:this.parentid,
        orderresult:(this.result / this.devicenums.length * 100).toFixed(2) + "%",
      }
      modifyParamsBatchLog(param)
    },
    setParams(){
      let param = {
        username:this.username,
        paramsobj:this.devicegroupname,
        paramsdate:moment(new Date()).format("YYYYMMDDHHmmss"),
        devicenum:"",
        devicegroupid:"0",
        orderresult:"0.00%",
        paramstype:'0',
      }
      addParamsBatchLog(param).then(res=>{
        if(res&&res.returncode=='0'){
          this.result=0;
          this.parentid=res.item[0].paramsid
          for(var i=0;i<this.devicenums.length;i++){
            this.setParamsConfig(this.devicenums[i],this.devicenames[i],res.item[0].paramsid)
          }
          this.$message.success("操作成功")
        }
      })
    },
    setParamsConfig(devicenum,devicename,parentid){
      this.paramsdata='';
      let paramsBody={}
      if(this.IotFlag.iotFlag==0) {
        paramsBody = {
          master: this.iotConfigs.master,
          welcome_audio_enable: this.iotConfigs.welcome_audio_enable,
          hei_threshold_base: this.iotConfigs.hei_threshold_base,
          out_cancle_time_span: this.iotConfigs.out_cancle_time_span,
          FAULE_OPEN_DOOR_TIME: this.iotConfigs.FAULE_OPEN_DOOR_TIME,
          FAULE_CLOSE_DOOR_TIME: this.iotConfigs.FAULE_CLOSE_DOOR_TIME,
          out_detect_enable_flag:this.iotConfigs.out_detect_enable_flag,
          all_fault_enable:this.iotConfigs.all_fault_enable,
          TRAPPED_PEOPLE_TIME: this.iotConfigs.TRAPPED_PEOPLE_TIME,
          alarm_enable: this.iotConfigs.alarm_enable,
          alarm_active_enable: this.iotConfigs.alarm_active_enable,
          Manufacture_mode: this.iotConfigs.Manufacture_mode,
          trapped_enable: this.iotConfigs.trapped_enable,
          safety_loop_enable: this.iotConfigs.safety_loop_enable,
          close_enable: this.iotConfigs.close_enable,
          open_enable: this.iotConfigs.open_enable,
          accidental_movement_enable: this.iotConfigs.accidental_movement_enable,
          motor_fault_enable: this.iotConfigs.motor_fault_enable,
          floor_loss_enable: this.iotConfigs.floor_loss_enable,
          trapped_alarm_enable: this.iotConfigs.trapped_alarm_enable,
          other_fault_enable: this.iotConfigs.other_fault_enable,
          recall_event_flag: this.iotConfigs.recall_event_flag,
          brightness_list_max:this.iotConfigs.brightness_list_max,
          brightness_mean_acc_interval:this.iotConfigs.brightness_mean_acc_interval,
          brightness_value_min:this.iotConfigs.brightness_value_min,
          brightness_value_max:this.iotConfigs.brightness_value_max,
          Service_Mode_upload_video_enable:this.iotConfigs.Service_Mode_upload_video_enable,
          passive_alarm_upload_video_enable:this.iotConfigs.passive_alarm_upload_video_enable,
          alarm_active_upload_video_enable:this.iotConfigs.alarm_active_upload_video_enable,
          safety_loop_upload_video_enable:this.iotConfigs.safety_loop_upload_video_enable,
          open_upload_video_enable:this.iotConfigs.open_upload_video_enable,
          close_upload_video_enable:this.iotConfigs.close_upload_video_enable,
          out_upload_video_enable:this.iotConfigs.out_upload_video_enable,
          accidental_movement_upload_video_enable:this.iotConfigs.accidental_movement_upload_video_enable,
          motor_upload_video_enable:this.iotConfigs.motor_upload_video_enable,
          floor_loss_upload_video_enable:this.iotConfigs.floor_loss_upload_video_enable,
          other_upload_video_enable:this.iotConfigs.other_upload_video_enable,
          trapped_fault_upload_video_enable:this.iotConfigs.trapped_fault_upload_video_enable,
          repeatedly_open_close_upload_video_enable:this.iotConfigs.repeatedly_open_close_upload_video_enable,
          open_run_upload_video_enable:this.iotConfigs.open_run_upload_video_enable,
        }
        if(this.iotConfigs.master==null||this.iotConfigs.master==""){this.$delete(paramsBody,'master')}else{this.paramsdata=this.paramsdata+"播放语音的音量,"+this.iotConfigs.master+","}
        if(this.iotConfigs.welcome_audio_enable==null||this.iotConfigs.welcome_audio_enable==""){this.$delete(paramsBody,'welcome_audio_enable')}else{this.paramsdata=this.paramsdata+"欢迎语音功能使能,"+this.iotConfigs.welcome_audio_enable+","}
        if(this.iotConfigs.hei_threshold_base==null||this.iotConfigs.hei_threshold_base==""){this.$delete(paramsBody,'hei_threshold_base')}else{this.paramsdata=this.paramsdata+"当前楼层测量高度和实际高度差值的阈值,"+this.iotConfigs.hei_threshold_base+","}
        if(this.iotConfigs.out_cancle_time_span==null||this.iotConfigs.out_cancle_time_span==""){this.$delete(paramsBody,'out_cancle_time_span')}else{this.paramsdata=this.paramsdata+"开锁区域外停止故障撤销时间,"+this.iotConfigs.out_cancle_time_span+","}
        if(this.iotConfigs.FAULE_OPEN_DOOR_TIME==null||this.iotConfigs.FAULE_OPEN_DOOR_TIME==""){this.$delete(paramsBody,'FAULE_OPEN_DOOR_TIME')}else{this.paramsdata=this.paramsdata+"开门最大超时时间,"+this.iotConfigs.FAULE_OPEN_DOOR_TIME+","}
        if(this.iotConfigs.FAULE_CLOSE_DOOR_TIME==null||this.iotConfigs.FAULE_CLOSE_DOOR_TIME==""){this.$delete(paramsBody,'FAULE_CLOSE_DOOR_TIME')}else{this.paramsdata=this.paramsdata+"关门最大超时时间,"+this.iotConfigs.FAULE_CLOSE_DOOR_TIME+","}
        if(this.iotConfigs.out_detect_enable_flag==null||this.iotConfigs.out_detect_enable_flag==""){this.$delete(paramsBody,'out_detect_enable_flag')}else{this.paramsdata=this.paramsdata+"轿厢在开锁区域外停止故障使能标志,"+this.iotConfigs.out_detect_enable_flag+","}
        if(this.iotConfigs.all_fault_enable==null||this.iotConfigs.all_fault_enable==""){this.$delete(paramsBody,'all_fault_enable')}else{this.paramsdata=this.paramsdata+"电梯物联网故障使能标志,"+this.iotConfigs.all_fault_enable+","}
        if(this.iotConfigs.TRAPPED_PEOPLE_TIME==null||this.iotConfigs.TRAPPED_PEOPLE_TIME==""){this.$delete(paramsBody,'TRAPPED_PEOPLE_TIME')}else{this.paramsdata=this.paramsdata+"长时间驻留最大超时时间,"+this.iotConfigs.TRAPPED_PEOPLE_TIME+","}
        if(this.iotConfigs.alarm_enable==null||this.iotConfigs.alarm_enable==""){this.$delete(paramsBody,'alarm_enable')}else{this.paramsdata=this.paramsdata+"无源报警功能使能,"+this.iotConfigs.alarm_enable+","}
        if(this.iotConfigs.alarm_active_enable==null||this.iotConfigs.alarm_active_enable==""){this.$delete(paramsBody,'alarm_active_enable')}else{this.paramsdata=this.paramsdata+"有源报警使能标志,"+this.iotConfigs.alarm_active_enable+","}
        if(this.iotConfigs.Manufacture_mode==null||this.iotConfigs.Manufacture_mode==""){this.$delete(paramsBody,'Manufacture_mode')}else{this.paramsdata=this.paramsdata+"生产模式使能,"+this.iotConfigs.Manufacture_mode+","}
        if(this.iotConfigs.trapped_enable==null||this.iotConfigs.trapped_enable==""){this.$delete(paramsBody,'trapped_enable')}else{this.paramsdata=this.paramsdata+"困人故障使能,"+this.iotConfigs.trapped_enable+","}
        if(this.iotConfigs.safety_loop_enable==null||this.iotConfigs.safety_loop_enable==""){this.$delete(paramsBody,'safety_loop_enable')}else{this.paramsdata=this.paramsdata+"安全回路断路故障使能,"+this.iotConfigs.safety_loop_enable+","}
        if(this.iotConfigs.close_enable==null||this.iotConfigs.close_enable==""){this.$delete(paramsBody,'close_enable')}else{this.paramsdata=this.paramsdata+"关门故障使能,"+this.iotConfigs.close_enable+","}
        if(this.iotConfigs.open_enable==null||this.iotConfigs.open_enable==""){this.$delete(paramsBody,'open_enable')}else{this.paramsdata=this.paramsdata+"开门故障使能,"+this.iotConfigs.open_enable+","}
        if(this.iotConfigs.accidental_movement_enable==null||this.iotConfigs.accidental_movement_enable==""){this.$delete(paramsBody,'accidental_movement_enable')}else{this.paramsdata=this.paramsdata+"轿厢意外移动故障使能,"+this.iotConfigs.accidental_movement_enable+","}
        if(this.iotConfigs.motor_fault_enable==null||this.iotConfigs.motor_fault_enable==""){this.$delete(paramsBody,'motor_fault_enable')}else{this.paramsdata=this.paramsdata+"电动机运转时间限制器动作使能,"+this.iotConfigs.motor_fault_enable+","}
        if(this.iotConfigs.floor_loss_enable==null||this.iotConfigs.floor_loss_enable==""){this.$delete(paramsBody,'floor_loss_enable')}else{this.paramsdata=this.paramsdata+"楼层位置丢失故障使能,"+this.iotConfigs.floor_loss_enable+","}
        if(this.iotConfigs.trapped_alarm_enable==null||this.iotConfigs.trapped_alarm_enable==""){this.$delete(paramsBody,'trapped_alarm_enable')}else{this.paramsdata=this.paramsdata+"困人绑定报警使能标志,"+this.iotConfigs.trapped_alarm_enable+","}
        if(this.iotConfigs.other_fault_enable==null||this.iotConfigs.other_fault_enable==""){this.$delete(paramsBody,'other_fault_enable')}else{this.paramsdata=this.paramsdata+"其它阻止电梯再启动的故障使能,"+this.iotConfigs.other_fault_enable+","}
        if(this.iotConfigs.recall_event_flag==null||this.iotConfigs.recall_event_flag==""){this.$delete(paramsBody,'recall_event_flag')}else{this.paramsdata=this.paramsdata+"故障撤销功能使能标志,"+this.iotConfigs.recall_event_flag+","}
        if(this.iotConfigs.brightness_list_max==null||this.iotConfigs.brightness_list_max==""){this.$delete(paramsBody,'brightness_list_max')}else{this.paramsdata=this.paramsdata+"亮度队列长度,"+this.iotConfigs.brightness_list_max+","}
        if(this.iotConfigs.brightness_mean_acc_interval==null||this.iotConfigs.brightness_mean_acc_interval==""){this.$delete(paramsBody,'brightness_mean_acc_interval')}else{this.paramsdata=this.paramsdata+"计算亮度队列均值时间间隔,"+this.iotConfigs.brightness_mean_acc_interval+","}
        if(this.iotConfigs.brightness_value_min==null||this.iotConfigs.brightness_value_min==""){this.$delete(paramsBody,'brightness_value_min')}else{this.paramsdata=this.paramsdata+"亮度最低阈值,"+this.iotConfigs.brightness_value_min+","}
        if(this.iotConfigs.brightness_value_max==null||this.iotConfigs.brightness_value_max==""){this.$delete(paramsBody,'brightness_value_max')}else{this.paramsdata=this.paramsdata+"亮度最高阈值,"+this.iotConfigs.brightness_value_max+","}
        if(this.iotConfigs.Service_Mode_upload_video_enable==null||this.iotConfigs.Service_Mode_upload_video_enable==""){this.$delete(paramsBody,'Service_Mode_upload_video_enable')}else{this.paramsdata=this.paramsdata+"检修事件上传录像使能,"+this.iotConfigs.Service_Mode_upload_video_enable+","}
        if(this.iotConfigs.passive_alarm_upload_video_enable==null||this.iotConfigs.passive_alarm_upload_video_enable==""){this.$delete(paramsBody,'passive_alarm_upload_video_enable')}else{this.paramsdata=this.paramsdata+"无源报警上传录像使能,"+this.iotConfigs.passive_alarm_upload_video_enable+","}
        if(this.iotConfigs.alarm_active_upload_video_enable==null||this.iotConfigs.alarm_active_upload_video_enable==""){this.$delete(paramsBody,'alarm_active_upload_video_enable')}else{this.paramsdata=this.paramsdata+"有源报警上传录像使能,"+this.iotConfigs.alarm_active_upload_video_enable+","}
        if(this.iotConfigs.safety_loop_upload_video_enable==null||this.iotConfigs.safety_loop_upload_video_enable==""){this.$delete(paramsBody,'safety_loop_upload_video_enable')}else{this.paramsdata=this.paramsdata+"安全回路断路故障上传录像使能,"+this.iotConfigs.safety_loop_upload_video_enable+","}
        if(this.iotConfigs.open_upload_video_enable==null||this.iotConfigs.open_upload_video_enable==""){this.$delete(paramsBody,'open_upload_video_enable')}else{this.paramsdata=this.paramsdata+"开门故障上传录像使能,"+this.iotConfigs.open_upload_video_enable+","}
        if(this.iotConfigs.close_upload_video_enable==null||this.iotConfigs.close_upload_video_enable==""){this.$delete(paramsBody,'close_upload_video_enable')}else{this.paramsdata=this.paramsdata+"关门故障上传录像使能,"+this.iotConfigs.close_upload_video_enable+","}
        if(this.iotConfigs.out_upload_video_enable==null||this.iotConfigs.out_upload_video_enable==""){this.$delete(paramsBody,'out_upload_video_enable')}else{this.paramsdata=this.paramsdata+"轿厢在开锁区域外停止故障上传录像使能,"+this.iotConfigs.out_upload_video_enable+","}
        if(this.iotConfigs.accidental_movement_upload_video_enable==null||this.iotConfigs.accidental_movement_upload_video_enable==""){this.$delete(paramsBody,'accidental_movement_upload_video_enable')}else{this.paramsdata=this.paramsdata+"轿厢意外移动故障上传录像使能,"+this.iotConfigs.accidental_movement_upload_video_enable+","}
        if(this.iotConfigs.motor_upload_video_enable==null||this.iotConfigs.motor_upload_video_enable==""){this.$delete(paramsBody,'motor_upload_video_enable')}else{this.paramsdata=this.paramsdata+"电动机运转时间限制器动作上传录像使能,"+this.iotConfigs.motor_upload_video_enable+","}
        if(this.iotConfigs.floor_loss_upload_video_enable==null||this.iotConfigs.floor_loss_upload_video_enable==""){this.$delete(paramsBody,'floor_loss_upload_video_enable')}else{this.paramsdata=this.paramsdata+"楼层位置丢失故障上传录像使能,"+this.iotConfigs.floor_loss_upload_video_enable+","}
        if(this.iotConfigs.other_upload_video_enable==null||this.iotConfigs.other_upload_video_enable==""){this.$delete(paramsBody,'other_upload_video_enable')}else{this.paramsdata=this.paramsdata+"其它阻止电梯再启动故障上传录像使能,"+this.iotConfigs.other_upload_video_enable+","}
        if(this.iotConfigs.trapped_fault_upload_video_enable==null||this.iotConfigs.trapped_fault_upload_video_enable==""){this.$delete(paramsBody,'trapped_fault_upload_video_enable')}else{this.paramsdata=this.paramsdata+"困人故障上传录像使能,"+this.iotConfigs.trapped_fault_upload_video_enable+","}
        if(this.iotConfigs.repeatedly_open_close_upload_video_enable==null||this.iotConfigs.repeatedly_open_close_upload_video_enable==""){this.$delete(paramsBody,'repeatedly_open_close_upload_video_enable')}else{this.paramsdata=this.paramsdata+"反复开关门故障上传录像使能,"+this.iotConfigs.repeatedly_open_close_upload_video_enable+","}
        if(this.iotConfigs.open_run_upload_video_enable==null||this.iotConfigs.open_run_upload_video_enable==""){this.$delete(paramsBody,'open_run_upload_video_enable')}else{this.paramsdata=this.paramsdata+"开门运行故障上传录像使能,"+this.iotConfigs.open_run_upload_video_enable+","}
      }else{
        paramsBody={
          floor_auto_check_lowest_num:this.iotConfigs.floor_auto_check_lowest_num,
          floor_auto_check_enable: this.iotConfigs.floor_auto_check_enable,
          PRESSURE_PRECISION: this.iotConfigs.PRESSURE_PRECISION,
          BASE_PTH: this.iotConfigs.BASE_PTH,
          T_Pi_ref: this.iotConfigs.T_Pi_ref,
          PRESSUER_LIST_MAX: this.iotConfigs.PRESSUER_LIST_MAX,
          all_fault_enable: this.iotConfigs.all_fault_enable,
          out_detect_enable_flag: this.iotConfigs.out_detect_enable_flag,
          AI_REALSTATE_RECEIVE_TIME: this.iotConfigs.AI_REALSTATE_RECEIVE_TIME,
          detect_other_fault_continuation_times: this.iotConfigs.detect_other_fault_continuation_times,
          cumulative_person_const: this.iotConfigs.cumulative_person_const,
          trapped_person_appear_probability: this.iotConfigs.trapped_person_appear_probability,
          out_cancel_car_move_continuation_times: this.iotConfigs.out_cancel_car_move_continuation_times,
          car_state_continuation_times: this.iotConfigs.car_state_continuation_times,
          after_up_no_out_fault_time: this.iotConfigs.after_up_no_out_fault_time,
          heartbeat_cycle: this.iotConfigs.heartbeat_cycle,
          motor_threshold: this.iotConfigs.motor_threshold,
          motor_continuation_times: this.iotConfigs.motor_continuation_times,
          motor_time_threshold: this.iotConfigs.motor_time_threshold,
          motor_cancel_time: this.iotConfigs.motor_cancel_time,
          loss_floor_pressure_lowest_threshold: this.iotConfigs.loss_floor_pressure_lowest_threshold,
          loss_floor_pressure_highest_threshold: this.iotConfigs.loss_floor_pressure_highest_threshold,
          loss_floor_continuation_times: this.iotConfigs.loss_floor_continuation_times,
          loss_fault_cancel_threshold: this.iotConfigs.loss_fault_cancel_threshold,
          loss_fault_cancel_continuation_times: this.iotConfigs.loss_fault_cancel_continuation_times,
          alarm_active_voltage_enable: this.iotConfigs.alarm_active_voltage_enable,
          alarm_voltage_enable: this.iotConfigs.alarm_voltage_enable,
          car_move_state_continuation_times: this.iotConfigs.car_move_state_continuation_times,
          floor_auto_check_run_times: this.iotConfigs.floor_auto_check_run_times,
          floor_auto_check_time: this.iotConfigs.floor_auto_check_time,
          gpio_active_time: this.iotConfigs.gpio_active_time,
          pressure_height_constant: this.iotConfigs.pressure_height_constant,
          pressure_height_constant_threshold: this.iotConfigs.pressure_height_constant_threshold,
          pressure_height_constant_list_max_len: this.iotConfigs.pressure_height_constant_list_max_len,
          before_long_stay: this.iotConfigs.before_long_stay,
          after_long_stay: this.iotConfigs.after_long_stay,
          step_threshold: this.iotConfigs.step_threshold,
          hei_threshold_hold_max_distance: this.iotConfigs.hei_threshold_hold_max_distance,
          hei_threshold_max: this.iotConfigs.hei_threshold_max,
          floor_sensor_mode: this.iotConfigs.floor_sensor_mode,
          pressure_height_constant_study_begin: this.iotConfigs.pressure_height_constant_study_begin,
          pressure_height_constant_study_end: this.iotConfigs.pressure_height_constant_study_end,
          repeatedly_open_close_time_threshold: this.iotConfigs.repeatedly_open_close_time_threshold,
          repeatedly_open_close_max: this.iotConfigs.repeatedly_open_close_max,
          open_cancle_time_span: this.iotConfigs.open_cancle_time_span,
          close_cancle_time_span: this.iotConfigs.close_cancle_time_span,
          pressure_height_constant_reference_list_max: this.iotConfigs.pressure_height_constant_reference_list_max,
          pressure_height_constant_reference_threshold: this.iotConfigs.pressure_height_constant_reference_threshold,
          double_door_calculation_cycle: this.iotConfigs.double_door_calculation_cycle,
          double_door_list_sum: this.iotConfigs.double_door_list_sum,
          double_door_list_max: this.iotConfigs.double_door_list_max,
          other_fault_reference_list_max: this.iotConfigs.other_fault_reference_list_max,
          other_fault_threshold: this.iotConfigs.other_fault_threshold,
          other_fault_cancel_threshold: this.iotConfigs.other_fault_cancel_threshold,
          mpu_read_cycle: this.iotConfigs.mpu_read_cycle,
          mpu_acceleration_list_num: this.iotConfigs.mpu_acceleration_list_num,
          mpu_acceleration_ref_list_num: this.iotConfigs.mpu_acceleration_ref_list_num,
          mpu_car_move_num: this.iotConfigs.mpu_car_move_num,
          mpu_car_move_threshold: this.iotConfigs.mpu_car_move_threshold,
          mpu_floor_loss_num: this.iotConfigs.mpu_floor_loss_num,
          mpu_floor_loss_threshold: this.iotConfigs.mpu_floor_loss_threshold,
          mpu_car_move_list_num: this.iotConfigs.mpu_car_move_list_num,
          block_door_time_threshold: this.iotConfigs.block_door_time_threshold,
          block_door_acc_threshold: this.iotConfigs.block_door_acc_threshold,
          other_fault_realtime_list_num: this.iotConfigs.other_fault_realtime_list_num,
        }
      }
      let paramsdate=moment(new Date()).format("YYYYMMDDHHmmss")
      let param = {
        username:this.username,
        paramsobj:devicename,
        paramsdate:paramsdate,
        devicenum:devicenum,
        devicegroupid:this.devicegroupid,
        orderresult:'失败',
        paramstype:'1',
        parentid:parentid,
        paramsdata:this.paramsdata,
      }
      addParamsBatchLog(param)
        let params = {
          devicenum: devicenum,
          data: [
            {
              modeltype: this.devicemoduletype,
              modelnum: this.modelnum,
              params: {
                methord: 'PUT',
                url:'/iot',
                body: paramsBody,
              }
            }
          ]
        };
        this.showLoading();
        setDeviceparamValueList(params).then(res => {
          this.hideLoading();
          if(res && res.returncode == '0') {
            this.result=this.result+1;
            let param = {
              username:this.username,
              paramsobj:devicename,
              paramsdate:paramsdate,
              devicenum:devicenum,
              devicegroupid:this.devicegroupid,
              orderresult:'成功',
              paramstype:'1',
              parentid:parentid,
              paramsdata:this.paramsdata,
            }
            modifyParamsBatchLog(param).then(res=>{
              if(res&&res.returncode=='0'){
                this.updateParams()
              }
            })
          }
        }).catch(err => {
          this.hideLoading();
          let param = {
            username: this.username,
            paramsobj: devicename,
            paramsdate: paramsdate,
            devicenum: devicenum,
            devicegroupid: this.devicegroupid,
            orderresult: '失败',
            paramstype: '1',
            parentid: parentid,
            paramsdata: this.paramsdata,
          }
          modifyParamsBatchLog(param)
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.params{
  flex-grow: 1;
  overflow: auto;
  width: 100%;
  height: 730px;
  //float: right;
  //margin-left: 0.5%;
  background-color: white;
  border-radius: 5px;
}
</style>